import { defaultClauseStatus, PromptsForFeature } from "../constants";
import { ADMIN_ACTIONS } from "./admin.thunk";

interface AdminSliceProps {
  [key: string]: {
    loading?: boolean;
    error?: {};
    data?: any;
  };
  roleManagementData: any;
}

const initialState: AdminSliceProps = {
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK]: {},
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_LIST]: {},
  [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK_VERTICAL_ADVANCED_LIST]: {},
  [PromptsForFeature.CONTRACT_REVIEW_TAB.CONTRACT_REVIEW_CLAUSE_CHECK_LIST]: {},
  [PromptsForFeature.TALK_TO_CONTRACT]: {},
  [PromptsForFeature.CONTRACT_EXECUTION]: {},
  [PromptsForFeature.CONTRACT_EXPIRY]: {},
  roleManagementData: {},
};

export default function adminReducer(state = initialState, action: any) {
  switch (action.type) {
    case ADMIN_ACTIONS.GET_PROMPTS:
      var feature = action.payload?.feature;
      state = {
        ...state,
        [feature]: {
          ...state[feature],
          ...action.payload.data,
        },
      };
      return state;

    case ADMIN_ACTIONS.GET_VERTICAL_LIST_DATA:
      feature = action.payload?.feature;
      state = {
        ...state,
        [feature]: {
          ...state[feature],
          ...action.payload.data,
        },
      };
      return state;

    case ADMIN_ACTIONS.UPDATE_CLAUSE:
      feature = action.payload?.feature;
      var name = action.payload?.name;
      var value = action.payload?.value;

      const featureData: any = state?.[feature]?.data?.slice() || [];
      const clauseIdx = featureData?.findIndex(
        (clause: any) => clause?.id === action?.payload?.clauseId
      );

      if (clauseIdx > -1) {
        const rulesCopy = featureData[clauseIdx]?.rules?.slice();
        const ruleIdx = rulesCopy?.findIndex(
          (rule: any) => rule?.name === name
        );

        if (ruleIdx > -1) {
          rulesCopy[ruleIdx] = {
            ...rulesCopy[ruleIdx],
            count: value,
          };

          featureData[clauseIdx] = {
            ...featureData[clauseIdx],
            rules: rulesCopy,
          };
        }
      }

      state = {
        ...state,
        [feature]: {
          ...state[feature],
          data: featureData,
        },
      };

      return state;

    case ADMIN_ACTIONS.ADD_NEW_KEYWORD_SECTION_FOR_TTC:
      const data: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCopy = data?.[0]?.rules?.slice();
      rulesCopy?.unshift(action.payload.prompt);

      const newData = {
        ...data[0],
        rules: rulesCopy,
      };

      data[0] = newData;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: data,
        },
      };

      return state;

    case ADMIN_ACTIONS.SAVE_NEW_SYNONYM_FOR_TTC:
      const idx = action.payload?.idx;
      const dataCopy: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp = dataCopy?.[0]?.rules?.slice();

      rulesCp[idx] = action.payload?.data;

      const newDataObj = {
        ...dataCopy[0],
        rules: rulesCp,
      };

      dataCopy[0] = newDataObj;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy,
        },
      };

      return state;

    case ADMIN_ACTIONS.DELETE_KEYWORD_SECTION_FOR_TTC:
      const idx1 = action.payload?.keywordId;
      const dataCopy1: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp1 = dataCopy1?.[0]?.rules?.slice();
      rulesCp1?.splice(idx1, 1);

      const newDataObj1 = {
        ...dataCopy1[0],
        rules: rulesCp1,
      };

      dataCopy1[0] = newDataObj1;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy1,
        },
      };
      return state;

    case ADMIN_ACTIONS.REMOVE_KEYWORDS_WITH_NEW_KEYWORD_TYPE:
      const dataCopy2: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp2 = dataCopy2?.[0]?.rules?.slice();
      const defaultRules = rulesCp2?.filter(
        (rule: any) => rule?.type === defaultClauseStatus.DEFAULT
      );

      const newDataObj2 = {
        ...dataCopy2[0],
        rules: defaultRules,
      };

      dataCopy2[0] = newDataObj2;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy2,
        },
      };

      return state;

    case ADMIN_ACTIONS.SET_ROLE_MANAGE_DATA:
      state = {
        ...state,
        roleManagementData: {
          ...state.roleManagementData,
          ...action.payload,
        },
      };

      return state;

    case ADMIN_ACTIONS.ADD_NEW_CLAUSE_CHECK:
      state = {
        ...state,
        [PromptsForFeature.CLAUSE_CHECK_TAB.ADD_NEW_CLAUSE_CHECK]:
          action.payload,
      };
      return state;

    case ADMIN_ACTIONS.GET_CLAUSE_CHECK_SUMMARY:
      state = {
        ...state,
        [PromptsForFeature.CLAUSE_CHECK_TAB.CLAUSE_CHECK]: {
          ...action.payload,
          data: {
            ...action.payload.data,
            results: {
              clauseCheckSummaryList:
                action.payload?.data?.results?.clauseCheckSummaryList,
            },
          },
        },
      };
      return state;

    case ADMIN_ACTIONS.GET_IMPORT_CLAUSE_CHECK_SUMMARY:
      state = {
        ...state,
        [PromptsForFeature.CLAUSE_CHECK_TAB.GET_IMPORT_CLAUSE_CHECK_SUMMARY]:
          action.payload,
      };

      return state;

    case ADMIN_ACTIONS.GET_CLAUSE_CHECK_SUMMARY_FOR_CONTRACT_REVIEW:
      state = {
        ...state,
        [PromptsForFeature.CONTRACT_REVIEW_TAB
          .CONTRACT_REVIEW_CLAUSE_CHECK_LIST]: action.payload,
      };
      return state;

    case ADMIN_ACTIONS.GET_CONTRACT_REVIEW_IMPORT_CLAUSE_CHECK_LIST:
      state = {
        ...state,
        [PromptsForFeature.CONTRACT_REVIEW_TAB
          .CONTRACT_REVIEW_IMPORT_CLAUSE_CHECK_LIST]: action.payload,
      };
      return state;

    default:
      return state;
  }
}
